import { create } from 'zustand';
import { createJSONStorage, persist } from 'zustand/middleware';
import { bookingType } from 'Models/Enums';

interface UseStatusFilterSettingsProps {
	ferryTripId?: string;
	filterByStatusVehicle?: string;
	filterByStatusPassenger?: string;
	filterByStatusFreight?: string;
	setFilterByStatusVehicle(statusId: string): void;
	setFilterByStatusPassenger(statusId: string): void;
	setFilterByStatusFreight(statusId: string): void;
	getSelectedStatusByBookingType(type: bookingType): string | undefined;
	setSelectedStatusByBookingType(type: bookingType, statusId?: string): void;
	reset(ferryTripId: string): void;
}

export const useStatusFilterSettings = create<UseStatusFilterSettingsProps, [['zustand/persist', unknown]]>(
	persist(
		(set, get) => ({
			ferryTripId: undefined,
			filterByStatusVehicle: undefined,
			filterByStatusPassenger: undefined,
			filterByStatusFreight: undefined,
			setFilterByStatusVehicle(statusId: string) {
				set(() => ({ filterByStatusVehicle: statusId }));
			},
			setFilterByStatusFreight(statusId: string) {
				set(() => ({ filterByStatusFreight: statusId }));
			},
			setFilterByStatusPassenger(statusId: string) {
				set(() => ({ filterByStatusPassenger: statusId }));
			},
			getSelectedStatusByBookingType(type: bookingType) {
				if (type === 'VEHICLE') {
					return get().filterByStatusVehicle ?? 'booked';
				}
				if (type === 'FREIGHT') {
					return get().filterByStatusFreight ?? 'booked';
				}
				return get().filterByStatusPassenger ?? 'booked';
			},
			setSelectedStatusByBookingType(type: bookingType, statusId: string) {
				if (type === 'VEHICLE') {
					set(() => ({ filterByStatusVehicle: statusId }));
				}
				if (type === 'FREIGHT') {
					set(() => ({ filterByStatusFreight: statusId }));
				}
				if (type === 'PASSENGER_ONLY') {
					set(() => ({ filterByStatusPassenger: statusId }));
				}
			},
			reset(ferryTripId: string) {
				set(() => ({
					filterByStatusVehicle: 'booked',
					filterByStatusPassenger: 'booked',
					filterByStatusFreight: 'booked',
					ferryTripId,
				}));
			},
		}),
		{
			name: 'check-in-status-store',
			storage: createJSONStorage(() => sessionStorage),
		},
	),
);
